import Main from '../views/index.vue'
import BindingWidget from '../components/binding/weixin.vue'
import { NavigationGuardNext, Route } from 'vue-router'

export default function() {
  return [
    {
      path: '/',
      component: Main,
      async beforeEnter(to: Route, from: Route, next: NavigationGuardNext) {
        const body = document.querySelector('body')
        if (body) {
          body.setAttribute('class', 'portal')
        }
        next()
      },
      meta: {
        title: '首页'
      },
      name: 'PortalHome',
      redirect: '/home',
      children: [
        {
          path: 'home',
          name: 'home',
          meta: {
            title: '首页',
            hideCrumb: true
          },
          component: () => import('../views/home/index.vue')
        },

        {
          // 意见反馈
          path: 'feedback',
          name: 'FeedBack',
          meta: {
            title: '意见反馈'
          },
          component: () => import('../views/feedback/index.vue')
        },
        {
          // 考试指南
          path: 'exam-guide',
          name: 'ExamGuide',
          component: () => import('../views/product/guide.vue')
        },

        {
          path: 'exam-sign-up',
          name: 'ExamSignUpCon',
          redirect: '/exam-sign-up',
          meta: {
            title: '考试报名'
          },
          component: {
            template: '<router-view/>'
          },
          children: [
            {
              path: '',
              name: 'ExamSignUp',
              component: () => import('../views/product/product-list.vue')
            },
            // 培训班商品详情
            {
              path: 'detail',
              meta: {
                title: '考试报名',
                hideCrumb: true
              },
              name: 'ExamSignUpDetail',
              component: () => import('../views/product/product-detail.vue')
            }
          ]
        },
        {
          path: 'exam-trend',
          meta: {
            title: '考试动态'
          },
          name: 'ExamTrend',
          component: () => import('../views/notice/notice-exam-trend.vue')
        },
        {
          path: 'exam-trend/:id',
          name: 'ExamTrendDetail',
          component: () => import('../views/notice/notice-detail.vue')
        },
        // 考试指南
        {
          path: 'help-details-static',
          meta: {
            title: '考试指南'
          },
          name: 'HelpDetailsStatic',
          component: () => import('../views/help-center/help-static-details.vue')
        },
        // 帮助中心
        {
          path: 'help-center',
          meta: {
            title: '帮助中心'
          },
          redirect: 'troubles',
          component: {
            template: '<router-view/>'
          },
          children: [
            {
              path: 'troubles',
              name: 'Troubles',
              meta: {
                title: '常见问题'
              },
              component: () => import('../views/help-center/troubles.vue')
            },
            {
              path: 'service-article',
              name: 'ServiceArticle',
              meta: {
                title: '服务条款'
              },
              component: () => import('../views/help-center/service-article.vue')
            }
          ]
        },
        // 关于我们
        {
          path: 'about',
          name: 'About',
          meta: {
            title: '关于我们'
          },
          component: () => import('../views/about/index.vue'),
          children: [
            {
              path: 'cooperation',
              name: 'Cooperation',
              meta: {
                title: '商业合作'
              },
              component: () => import('../views/about/cooperation.vue')
            },
            {
              path: 'relation',
              name: 'Relation',
              meta: {
                title: '联系我们'
              },
              component: () => import('../views/about/relation.vue')
            }
          ]
        },
        {
          path: 'teacher',
          name: 'Teacher',
          meta: {
            title: '名师风采'
          },
          component: () => import('../views/teacher/index.vue')
        },
        {
          // 忘记密码
          path: '/forgot-password',
          name: 'ForgotPassword',
          meta: {
            title: '忘记密码'
          },
          component: () => import('../views/forgot-password/forgot-password.vue')
        }
      ]
    },
    {
      path: '/index-preview',
      name: 'indexPreview',
      async beforeEnter(to: Route, from: Route, next: NavigationGuardNext) {
        const body = document.querySelector('body')
        if (body) {
          body.setAttribute('class', 'portal')
        }
        next()
      },
      meta: {
        title: '机构首页预览',
        needLogin: false
      },
      component: () => import('../views/home/index-preview.vue')
    },
    {
      path: '/create-order',
      name: 'CreateOrder',
      meta: {
        needLogin: true
      },
      component: () => import('../views/product/create-order/index.vue')
    },
    {
      path: '/binding-wx',
      name: 'BindingWeixin',
      component: BindingWidget
    },
    {
      path: '/pay-order',
      name: 'PayOrder',
      meta: {
        needLogin: true
      },
      component: () => import('../views/product/pay-order.vue')
    },
    {
      // 支付回调页
      path: '/pay-result',
      props: true,
      name: 'PayResult',
      meta: {
        needLogin: true
      },
      component: () => import('../views/product/pay-result.vue')
    }
  ]
}
